import { render, staticRenderFns } from "./bindcakeTag.vue?vue&type=template&id=9ea4d970&scoped=true"
import script from "./bindcakeTag.vue?vue&type=script&lang=js"
export * from "./bindcakeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea4d970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ea4d970')) {
      api.createRecord('9ea4d970', component.options)
    } else {
      api.reload('9ea4d970', component.options)
    }
    module.hot.accept("./bindcakeTag.vue?vue&type=template&id=9ea4d970&scoped=true", function () {
      api.rerender('9ea4d970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/lists/bindcakeTag.vue"
export default component.exports